import { isEqual } from 'lodash';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { Options as RRuleOptions } from 'rrule';
import { MBCalendar } from '@shared/components/dateAndTime/calendar';
import { getHighlightDates } from './utils';

interface EndDatePickerCalendarProps {
  selectedDate: Date;
  onSelect(date: Date): void;
  minDate?: Date;
  rruleOptions?: Partial<RRuleOptions>;
}

export function EndDatePickerCalendar({
  selectedDate,
  onSelect,
  minDate,
  rruleOptions,
}: EndDatePickerCalendarProps) {
  const selectedIso = useMemo(() => selectedDate.toISOString(), [selectedDate]);
  const selectedDatesArr = useMemo(() => [selectedIso], [selectedIso]);

  const [highlightDates, setHighlightDates] = useState<string[] | undefined>();

  const computeHighlightDates = useCallback(
    (monthStartISO: string) => {
      const dates = getHighlightDates({ rruleOptions, monthStartISO, endCapDate: selectedDate });
      setHighlightDates(prev => (isEqual(prev, dates) ? prev : dates));
    },
    [rruleOptions, selectedDate],
  );

  useEffect(() => {
    computeHighlightDates(selectedIso);
  }, [computeHighlightDates, selectedIso]);

  return (
    <MBCalendar
      selectedDates={selectedDatesArr}
      minDate={minDate?.toISOString()}
      onSelectDate={isoStr => onSelect(new Date(isoStr))}
      highlightDates={highlightDates}
      onMonthChange={rruleOptions ? computeHighlightDates : undefined}
    />
  );
}
